export type AmazonLocale = 'US' | 'UK' | 'DE';

export type ProductBadge = 'Prime' | "Amazon's Choice" | 'Coupon' | 'Limited Time Deal';

export enum AffiliateBadgeType {
  AmazonChoice = 'amazons-choice',
  Prime = 'prime',
  Coupon = 'coupon',
  LimitedTimeDeal = 'limited-time-deal',
}

export interface AffiliateProductPrice {
  amount: number;
  currency: string;
}

export interface AffiliateProduct {
  id: string;
  asin: string;
  title: string;
  originalPrice: AffiliateProductPrice | null;
  afterDiscountPrice: AffiliateProductPrice | null;
  imageUrls: {
    large: string;
    small: string;
    medium: string;
  };
  badge: ProductBadge;
  affiliateUrl: string;
  category: string;
  locale: string; // Amazon marketplace locale
  mainCategory?: string;
}
export interface AffiliateProductDTO {
  id: string;
  asin: string;
  title: string;
  original_price: AffiliateProductPrice | null;
  after_discount_price: AffiliateProductPrice | null;
  image_urls: {
    large: string;
    small: string;
    medium: string;
  };
  badge: ProductBadge;
  affiliate_url: string;
  category: string;
  locale: string; // Amazon marketplace locale
  main_category?: string;
}

export interface GetAffiliateProductsParams {
  userUuid: string;
  locale: AmazonLocale;
  shipmentId: string;
  page?: number;
  limit?: number;
}

export interface AffiliateProductsResponse {
  data: AffiliateProductDTO[];
  count: number;
  num_pages: number;
}

export interface AffiliateEvent {
  event_type: 'impression' | 'click';
  platform: string;
  url: string;
  product_id: string;
  locale: string;
  timestamp: string;
  main_category?: string;
}

export interface AffiliateSession {
  sessionId: string;
  userId?: string;
  startTime: number;
  lastActivityTime: number;
  isActive: boolean;
}

export interface BatchSubmissionPayload {
  events: AffiliateEvent[];
  sessionInfo: AffiliateSession;
  batchId: string;
  timestamp: number;
}

export interface AffiliateTrackingConfig {
  batchInterval: number;
  sessionTimeout: number;
  maxRetries: number;
  baseRetryDelay: number;
  maxRetryDelay: number;
}

export interface RetryContext {
  attempt: number;
  lastError?: Error;
  nextRetryTime?: number;
  payload: BatchSubmissionPayload;
}

export interface TrackingServiceOptions {
  config?: Partial<AffiliateTrackingConfig>;
  onEventTracked?: (event: AffiliateEvent) => void;
  onBatchSubmitted?: (batch: BatchSubmissionPayload) => void;
  onError?: (error: Error, context?: RetryContext) => void;
}

export interface TrackEventParams {
  eventType: 'impression' | 'click';
  productId: string;
  url: string;
  locale?: string;
  mainCategory?: string;
}
